import { FormControlLabel, Radio as MuiRadio, RadioProps as MuiRadioProps } from '@mui/material';
import { forwardRef } from 'react';

type Props = Pick<
  MuiRadioProps,
  | 'checked'
  | 'defaultChecked'
  | 'disabled'
  | 'onChange'
  | 'size'
  | 'name'
  | 'id'
  | 'required'
  | 'value'
  | 'slotProps'
  | 'className'
  | 'sx'
> & {
  label?: React.ReactNode;
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
};

const Radio = forwardRef<HTMLButtonElement, Props>(
  (
    {
      label,
      labelPlacement = 'end',
      className,
      sx,
      checked,
      defaultChecked,
      disabled,
      onChange,
      size,
      name,
      id,
      required,
      value,
      slotProps,
    },
    ref,
  ) => {
    const inputProps = {
      checked,
      defaultChecked,
      disabled,
      onChange,
      size,
      name,
      id,
      required,
      value,
      slotProps,
    };

    if (label !== undefined) {
      return (
        <FormControlLabel
          control={<MuiRadio {...inputProps} ref={ref} />}
          label={label}
          labelPlacement={labelPlacement}
          className={className}
          sx={sx}
        />
      );
    }

    return <MuiRadio {...inputProps} ref={ref} className={className} sx={sx} />;
  },
);

Radio.displayName = 'Radio';
export type { Props as RadioProps };
export default Radio;
